var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 3.75H8.33268L11.666 6.66667",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 11.25H1.66602",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08268 6.25L8.74935 7.91667C9.2096 8.37692 9.2096 9.12308 8.74935 9.58333C8.28912 10.0436 7.54292 10.0436 7.08268 9.58333L5.83268 8.33333C5.11544 9.05058 3.97994 9.13125 3.16847 8.52267L2.91602 8.33333",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 9.16732V16.2507H18.3327V7.08398H8.33268",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7077 11.6673C12.7077 12.4727 12.0548 13.1257 11.2493 13.1257C10.4439 13.1257 9.79102 12.4727 9.79102 11.6673C9.79102 10.8619 10.4439 10.209 11.2493 10.209C12.0548 10.209 12.7077 10.8619 12.7077 11.6673Z",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.cc1a84fe74d98dcb4e5b540e1db30302.svg";
export { ForwardRef as ReactComponent };